var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attchment-for-tenant" }, [
    _c(
      "div",
      { staticClass: "attachments", attrs: { id: "attachments" } },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("handover.attachmentsForTenant"))),
        ]),
        _vm._v(" "),
        _vm.allowEdit
          ? _c("HkldDropzone", { attrs: { sourceId: _vm.pubDocResourceId } })
          : _vm._e(),
        _vm._v(" "),
        _c("EditAttachments", {
          ref: "editAttachments",
          attrs: {
            sourceId: _vm.pubDocResourceId,
            canEdit: _vm.allowEdit,
            canDelete: _vm.allowEdit,
            canDownloadAll: false,
            getFilesList: _vm.getFilesList,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isWappr && _vm.isEmpty,
                expression: "isWappr && isEmpty",
              },
            ],
          },
          [_vm._v("--")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }